import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from '../shared/services/app.service';
declare var $: any;

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  index: any = 0;
  totalNotificationCount: any = 0;
  nextCount: any = 0;
  prevCount: any = 0;
  notifylist: any;
  skipNotifyCount: any = 0;
  loginDetails: any = {};
  maxNotifyCount: any = 0;
  unreadNotificationCount: any = 0;
  toastMsg: any;

  constructor(
    public translate: TranslateService,
    private AppService: AppService
  ) { }

  ngOnInit(): void {
    this.loginDetails = JSON.parse(
      localStorage.getItem('loginDetails') || '{}'
    );
    this.getAllNotifications(
      this.skipNotifyCount,
      this.loginDetails.registeredOn
    );
    this.getNotifications();
  }

  // list of notification
  addNotifytoDisplay(notifyArry: any) {
    this.notifylist = '';
    $('#notificationArrayList').empty();

    if (notifyArry.length > 0) {
      for (let k = 0; k < notifyArry.length; k++) {
        let originalDate = new Date(notifyArry[k].publishOn);
        // Format options for the desired output
        var options: any = {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        };

        var formattedDate = originalDate.toLocaleString('en-US', options);
        // Add "IST" at the end
        formattedDate += ' IST';
        this.notifylist += notifyArry[k].content;
        this.notifylist += '<span><b>Published on: </b>' + formattedDate + '</span>'
        if (k != notifyArry.length) {
          this.notifylist += '<hr class="notify-hr" />';
        }
      }
      $('#notificationArrayList').append(this.notifylist);
    } else {
      this.notifylist = '<div><b>No more notifications<b/></div>';
      $('#notificationArrayList').append(this.notifylist);
    }
  }

  // function to get all notifications based on your last login and notification session
  getAllNotifications(count: any, registeredOn: any) {
    this.skipNotifyCount = count;
    this.AppService.getAllNotifications(count, registeredOn).subscribe(
      (response: any) => {
        if (response.statusCode === 200) {
          this.maxNotifyCount = response.count;
          if (response.record) {
            this.addNotifytoDisplay(response.record);
          }
        } else if (response.statusCode === 401) {
          this.triggerToast(this.AppService.getResourceText('B000'));
          // localStorage.clear();
          setTimeout(function () {
            window.location.href = '/login';
          }, 3000);
        } else if (response.statusCode === 500) {
        }
      }
    );
  }

  // function to get all unread notifications count based on your last login and notification session
  getNotifications() {
    let userDetails = { userID: localStorage.getItem('userID') };
    this.AppService.getNotifications(userDetails).subscribe((response: any) => {
      if (response.statusCode === 200) {
        this.unreadNotificationCount = response.count;
      }
    });
  }

  // function to generate toast message bar
  triggerToast(message: any) {
    // console.log('toast message', message);
    this.toastMsg = message;
    $('#snackbar').html(message);
    var x: any = document.getElementById('snackbar');
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
    $('#errorMessagePopup').modal('show');
  }

  createActivity(appname: any) {
    var sessionID = localStorage.getItem('sessionID');
    var projectID = localStorage.getItem('projectID');
    var userID = localStorage.getItem('userID');
    if (sessionID == null) {
      sessionID = '';
    }
    let activityData = {
      appname: appname,
      sessionid: sessionID,
      projectid: projectID,
      userid: userID,
    };

    this.AppService.updateActivity(activityData).subscribe((response: any) => {
      if (response.statusCode === 200) {
        if (response.sessionid != undefined) {
          localStorage.setItem('sessionID', response.sessionid);
          this.getNotifications();
        }
        if (localStorage.getItem('sessionID') != undefined && appname == 'No') {
          this.getNotifications();
        }
      }
    });
  }
}
